import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import { customScript } from "../../common/customscript";
import { useEffect } from "react";
import ServicesSection from "../../components/services/services";
import SearchModel from "../../components/search_model/search";

const Services = () => {
    useEffect(() => {
        customScript()
    },[])

    return (
        <>
            <Header />
            <ServicesSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Services